let config;

config = {
    //api_url: "https://localhost:7043/api/v1/",
    api_url: "https://dc-prd-cct-api.dcc8fc7.eas.morningstar.com/api/v1/",
    audioFileType:".mp3,.mp4",
    pptFileType:".pdf,.ppt",
    transcriptFileType:".pdf,.doc,.docx",
    alertTime:5, // seconds
  };

  export default config;